import Modal from './Modal'
import { SecondaryButton, PrimaryButton, DangerButton, TertiaryButton } from "./Buttons/Button";
import { trans } from "../../utils/utilsTrans";

const ModalConfirm = ({ title, text, onConfirm, closeModal, textConfirm, isDanger, loading }) => {
  let CompButton = PrimaryButton
  if (isDanger) CompButton = DangerButton
  return (
    <Modal type={'small'} closeModal={() => !loading ? closeModal() : null} hasCloseButton={false}>
      <div className={'p-32'}>
        <h4 className='text-lg font-bold'>{title}</h4>
        {text ? <span className={'block text-sm text-greyLight2 mt-16'}>{text}</span> : null}
        <div className={'flex justify-end space-x-16 mt-40'}>
          <TertiaryButton
            text={trans('cancel')}
            onClick={closeModal}
            disabled={loading}
            cypress='cancel'
          />
          <CompButton
            loading={loading}
            text={textConfirm || trans('validate')}
            onClick={onConfirm}
            cypress={'modal-confirm'}
          />
        </div>
      </div>
    </Modal>
  )
}

export default ModalConfirm
